import { useEffect } from 'react';
import InterestsSelectionModal from 'src/components/InterestsSelectionModal';
import useSignupInterests from 'src/hooks/useSignupInterests';
import { ModalType } from 'src/types/Modal';
import { OrderedModalHookType } from './types';
import withLoginUserModalPromise from './withLoginUserModalPromise';
const useSignupInterestsModal: OrderedModalHookType = modalPropsPromise => {
  const {
    hasInterestSelectionStep,
    categorizedInterests,
    minCount,
    maxCount,
    isFetching,
    isSkipEnabled
  } = useSignupInterests();
  useEffect(() => {
    if (!modalPropsPromise) return;
    if (isFetching) return;

    // 회원가입 후 수행해야 하는 스텝 목록에 INTEREST_SELECTION이 포함되어 있지 않으면 관심사 선택 모달 노출 안 함
    if (!hasInterestSelectionStep) {
      modalPropsPromise.resolve(null);
      return;
    }
    modalPropsPromise.resolve([{
      modalProps: {
        key: ModalType.INTERESTS_SELECTION,
        component: () => <InterestsSelectionModal trigger='SIGN_UP' categorizedInterests={categorizedInterests} minCount={minCount} maxCount={maxCount} isSkipEnabled={isSkipEnabled} />
      }
    }]);
  }, [modalPropsPromise, isFetching, hasInterestSelectionStep, categorizedInterests, minCount, maxCount, isSkipEnabled]);
};
export default withLoginUserModalPromise(useSignupInterestsModal);